import React, { Component } from 'react';
import { connect } from 'react-redux';
import {CSSTransition,TransitionGroup} from 'react-transition-group';
import { setCookie } from '../../services/Utils'

// Actions
import { configure, getConfiguration } from '../../actions/Settings'
import { getAnnouncements } from '../../actions/Announcements'

// Components
import Announcement from './Announcement';
import TopBanner from './TopBanner';
import Portal from '../Portal'

/**
 * TASKS:
 * [ ] Get Items
 * [ ] Add Close Button to Announcement
 * [ ] Remove Item when Close is clicked.
 */

// Class
class TCCAnnouncements extends Component {

    // static getDerivedStateFromProps(props, state) {

    //     // Return null if the state hasn't changed
    //     return {
    //         items: props.announcements.items,
    //     };
    //     return null;
    //   }


    constructor(props){

        super(props);

        this.state = {
            loaded: false,
            className: 'loading',
            pid: this.props.pid,
            items: {},
            notificationIndex: 0,
            notificationTime: (this.props.time) ? this.props.time : 3000,
            notificationClosed: false,
            topbannerClosed: false,
            topbannerIndex: 0,
        }

        this.htmlBody = document.querySelector('body')
        this.htmlBodyContentSelector = 'body'
        
    }

    getItems(){
        this.props.getAnnouncements({pid:this.props.pid})
    }

    componentDidMount(){

        // Get Configuration
        this.props.configure(this.props.site);
        this.props.getConfiguration();

        // Get Announcsments
        this.getItems();

        // Set Timer
        this.timer();
       
    }

    timer(){
        
        // Notification
        setInterval(() => {
            const {items} = this.props.announcements;
            if(!items) return;
            const {notifications} = items;
            if(this.state.notificationIndex === (notifications.length-1)) this.setState({notificationIndex:0});
            else this.setState({notificationIndex: this.state.notificationIndex+1})
           
        },this.state.notificationTime);
    }



    handleClose(item){

        // Set Cookie To Remember this has been seen.
        setCookie('announcement_seen_'+item.ID,true);

        // Close Everything.
        this.setState({notificationClosed:true,notificationIndex:null});
    }

    handleTopBannerClose(item){

        // Set Cookie To Remember this has been seen.
        setCookie('announcement_seen_'+item.ID,true);

        // Close Everything.
        this.setState({topbannerClosed:true,topbannerIndex:null});

        // Remove HTML Class
        this.htmlBody.classList.remove("announcement-topbanner-open");
    
    }

    renderNotificationBody(){

        // Guard: Not loaded
        if(this.props.announcements.ui === 'loading') return (<div className={this.state.className}></div>);
        const item = this.props.announcements.items.notifications[this.state.notificationIndex];
        
        return (
            <div className="announcements">
                <TransitionGroup>
                    <CSSTransition key={item.ID} timeout={1000} classNames="announcementitemtransition">
                        <Announcement onClose={() => this.handleClose(item)} {...item} />
                    </CSSTransition>
                </TransitionGroup>
            </div>
        );

    }

    renderNotifications(){
        // Guard: Not loaded
        if(!this.props.announcements.items) return (
            <div className="announcement-notifications">
                <TransitionGroup>
                    <CSSTransition key="no-items" timeout={1000} classNames="announcementclosetransition">
                        <div className={this.state.className}></div>
                    </CSSTransition>
                </TransitionGroup>
            </div>
        );

        // Guard: Closed of No items
        if(this.state.notificationClosed === true || !this.props.announcements.items.notifications.length) return (
        <div className="announcement-notifications">
            <TransitionGroup>
                <CSSTransition key="no-items" timeout={1000} classNames="announcementclosetransition">
                    <div className="closed-announcements"></div>
                </CSSTransition>
            </TransitionGroup>
        </div>
        ) 


        return (
        <div className="announcement-notifications">
            <TransitionGroup>
                <CSSTransition key="has-items" timeout={1000} classNames="announcementclosetransition">
                <div className={this.state.className}>
                    {this.renderNotificationBody()}
                </div>
                </CSSTransition>
            </TransitionGroup>
        </div>
        )
    }

    renderTopBanner(){


        // Guard: Not loaded
        if(!this.props.announcements.items) return (
            <Portal selector={this.htmlBodyContentSelector} insertBefore="true">
                <div className="announcement-topbanners">
                    <TransitionGroup>
                        <CSSTransition key="no-items" timeout={1000} classNames="announcementtopbannerclosetransition">
                            <div className={this.state.className}></div>
                        </CSSTransition>
                    </TransitionGroup>
                </div>
            </Portal>
        );

        if(this.state.topbannerClosed === true || !this.props.announcements.items.topbanners.length) return (
            <Portal selector={this.htmlBodyContentSelector} insertBefore="true">
            <div className="announcement-topbanners">
                <TransitionGroup>
                    <CSSTransition key="no-items" timeout={1000} classNames="announcementtopbannerclosetransition">
                        <div className="closed-announcements"></div>
                    </CSSTransition>
                </TransitionGroup>
            </div>
            </Portal>
        ) 

        // Only Use 1 for now.
        const item =  this.props.announcements.items.topbanners[0];
        this.htmlBody.classList.add("announcement-topbanner-open");

        return (
            <Portal selector={this.htmlBodyContentSelector} insertBefore="true">
            <div className="announcement-topbanners">
                <TransitionGroup>
                    <CSSTransition key="has-items" timeout={1000} classNames="announcementtopbaritemtransition">
                        <div className={this.state.className}>
                            <TopBanner onClose={() => this.handleTopBannerClose(item)} {...item} />
                        </div>
                    </CSSTransition>
                </TransitionGroup>
            </div>
            </Portal>
        )
    }

    render(){

        return (
            <div className="announcements-wrapper">
                {this.renderNotifications()}
                {this.renderTopBanner()}
            </div>
        )
        
    }

}

const mapStateToProps = state => ({
    settings: state.Settings,
    announcements: state.Announcements
})

const mapDispatchToProps = dispatch => ({
    configure: (site) => dispatch(configure(site)),
    getConfiguration: () => dispatch(getConfiguration()),
    getAnnouncements: (args) => dispatch(getAnnouncements(args)),
})

export default connect(mapStateToProps, mapDispatchToProps)(TCCAnnouncements);
